<template>
    <div :class="cn(alertVariants({ variant }), props.class)" role="alert">
        <Icon :name="iconName" class="absolute text-xl top-4 left-4" />
        <slot />
    </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { alertVariants, type AlertVariants } from "~/components/ui";
import type { IconName } from "../Icon.vue";

const props = defineProps<{
    class?: HTMLAttributes["class"];
    variant?: AlertVariants["variant"];
}>();

const iconName = computed<IconName>(() => {
    if (props.variant == "danger") return "exclamation-triangle";
    return "info-circle";
});
</script>
